import { IDonorConnectIncidentLog } from '@nkr/models/index';
import { Alert, Button, Col, ControlLabel, Modal, Row } from 'react-bootstrap';
import ReactHtmlParser from 'react-html-parser';
import { RowWrapper } from './styles';

interface IProps {
    show: boolean,
    data: IDonorConnectIncidentLog,
    container: any,
    onDelete: () => void,
    onCancel: () => void
}

const DeleteLogEntryConfirmation = (props: IProps) => {
    if (props.data == null)
        return null;

    return (
        <Modal show={props.show} onHide={props.onCancel} container={props.container}>
            <Modal.Header>
                Delete Log Entry?
            </Modal.Header>
            <Modal.Body>
                <Alert bsStyle='danger' style={{ marginBottom: 10, paddingTop: 7.5, paddingBottom: 7.5, textAlign: 'center' }}>
                    Are you sure you want to delete the following log entry?
                </Alert>

                <div style={{ paddingLeft: 10 }}>
                    <RowWrapper>
                        <Col xs={12} lg={3} componentClass={ControlLabel}>Created</Col>
                        <Col xs={12} lg={9}>
                            <div>{props.data.logDateTimeForDisplay}</div>
                        </Col>
                    </RowWrapper>

                    <RowWrapper>
                        <Col xs={12} lg={3} componentClass={ControlLabel}>Created By</Col>
                        <Col xs={12} lg={9}>
                            <div>{props.data.createdByFullName}</div>
                        </Col>
                    </RowWrapper>

                    {props.data.updateDateTimeForDisplay != '' && (
                        <>
                            <RowWrapper>
                                <Col xs={12} lg={3} componentClass={ControlLabel}>Last Updated</Col>
                                <Col xs={12} lg={9}>
                                    <div>{props.data.updateDateTimeForDisplay}</div>
                                </Col>
                            </RowWrapper>

                            <RowWrapper>
                                <Col xs={12} lg={3} componentClass={ControlLabel}>Last Updated By</Col>
                                <Col xs={12} lg={9}>
                                    <div>{props.data.updatedByFullName}</div>
                                </Col>
                            </RowWrapper>
                        </>
                    )}

                    <RowWrapper>
                        <Col xs={12} lg={3} componentClass={ControlLabel}>Action Taken</Col>
                        <Col xs={12} lg={9}>
                            <div>{props.data.actionTaken}</div>
                        </Col>
                    </RowWrapper>

                    <Row>
                        <Col xs={12} lg={3} componentClass={ControlLabel}>Comments</Col>
                        <Col xs={12} lg={9}>
                            <div>{ReactHtmlParser(props.data.comments.replace(/(?:\r\n|\r|\n)/g, '<br/>'))}</div>
                        </Col>
                    </Row>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='danger' onClick={props.onDelete}>Delete</Button>
                <Button bsStyle='link' onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default DeleteLogEntryConfirmation;